/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/credit_consumption_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { analyticsDashboardAppGroupIdCreditConsumptionData } from "./constants";
import type { AnalyticsDashboardCreditConsumptionDataResult } from "./types";

export const getAnalyticsDashboardAppGroupIdCreditConsumptionData = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdCreditConsumptionData,
  (signal: AbortSignal, appGroupId: string): Promise<AnalyticsDashboardCreditConsumptionDataResult> => {
    return fetch(`/analytics_dashboard/${appGroupId}/credit_consumption_data`, "GET", {}, { signal });
  }
);
